import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_3f381d0f from 'nuxt_plugin_plugin_3f381d0f' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_recaptcha_698222ec from 'nuxt_plugin_recaptcha_698222ec' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_nuxtplugine07df562_eec79eb0 from 'nuxt_plugin_nuxtplugine07df562_eec79eb0' // Source: ./nuxt.plugin.e07df562.js (mode: 'server')
import nuxt_plugin_vuescrollto_a2e47728 from 'nuxt_plugin_vuescrollto_a2e47728' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_cd293eb6 from 'nuxt_plugin_cookieuniversalnuxt_cd293eb6' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_c4e66644 from 'nuxt_plugin_pluginutils_c4e66644' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginseo_a193409c from 'nuxt_plugin_pluginseo_a193409c' // Source: ./nuxt-i18n/plugin.seo.js (mode: 'all')
import nuxt_plugin_pluginrouting_238d9aa9 from 'nuxt_plugin_pluginrouting_238d9aa9' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_19b70d34 from 'nuxt_plugin_pluginmain_19b70d34' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_distplugin63fa6690_6d4c3434 from 'nuxt_plugin_distplugin63fa6690_6d4c3434' // Source: ./dist.plugin.63fa6690.mjs (mode: 'all')
import nuxt_plugin_image_498c57f8 from 'nuxt_plugin_image_498c57f8' // Source: ./image.js (mode: 'all')
import nuxt_plugin_coreplugine6901026_1f62471a from 'nuxt_plugin_coreplugine6901026_1f62471a' // Source: ./core.plugin.e6901026.ts (mode: 'all')
import nuxt_plugin_pluginse2etestinga6d710e6_d36a14fc from 'nuxt_plugin_pluginse2etestinga6d710e6_d36a14fc' // Source: ./plugins.e2e-testing.a6d710e6.js (mode: 'all')
import nuxt_plugin_deviceplugin_9676b4f0 from 'nuxt_plugin_deviceplugin_9676b4f0' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_workbox_546b04d9 from 'nuxt_plugin_workbox_546b04d9' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_3a8262ec from 'nuxt_plugin_metaplugin_3a8262ec' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_3f2a0860 from 'nuxt_plugin_iconplugin_3f2a0860' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_tokenexpired_ca1e20ca from 'nuxt_plugin_tokenexpired_ca1e20ca' // Source: ../plugins/token-expired (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_fcPlugin_5a846bc6 from 'nuxt_plugin_fcPlugin_5a846bc6' // Source: ../plugins/fcPlugin (mode: 'all')
import nuxt_plugin_dompurify_9e093c4a from 'nuxt_plugin_dompurify_9e093c4a' // Source: ../plugins/dompurify (mode: 'all')
import nuxt_plugin_storeConfigPlugin_234467e0 from 'nuxt_plugin_storeConfigPlugin_234467e0' // Source: ../plugins/storeConfigPlugin (mode: 'all')
import nuxt_plugin_pwa_4462a11a from 'nuxt_plugin_pwa_4462a11a' // Source: ../plugins/pwa.js (mode: 'all')
import nuxt_plugin_meta_515c203e from 'nuxt_plugin_meta_515c203e' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const store = null
  const router = await createRouter(ssrContext, config, { store })

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"@vue-storefront\u002Fmagento-theme","meta":[{"charset":"utf8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"\u003C!-- ALL-CONTRIBUTORS-BADGE:START - Do not remove or modify this section --\u003E [![All Contributors](https:\u002F\u002Fimg.shields.io\u002Fbadge\u002Fall_contributors-21-orange.svg?style=flat-square)](#contributors-) \u003C!-- ALL-CONTRIBUTORS-BADGE:END --\u003E"},{"name":"generator","content":"Vue Storefront 2"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"script":[{"async":true,"src":"https:\u002F\u002Fstatic-na.payments-amazon.com\u002Fcheckout.js"},{"async":true,"src":"https:\u002F\u002Fwww.google.com\u002Frecaptcha\u002Fapi.js?hl=it"}],"style":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_3f381d0f === 'function') {
    await nuxt_plugin_plugin_3f381d0f(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_698222ec === 'function') {
    await nuxt_plugin_recaptcha_698222ec(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtplugine07df562_eec79eb0 === 'function') {
    await nuxt_plugin_nuxtplugine07df562_eec79eb0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_a2e47728 === 'function') {
    await nuxt_plugin_vuescrollto_a2e47728(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_cd293eb6 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_cd293eb6(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_c4e66644 === 'function') {
    await nuxt_plugin_pluginutils_c4e66644(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginseo_a193409c === 'function') {
    await nuxt_plugin_pluginseo_a193409c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_238d9aa9 === 'function') {
    await nuxt_plugin_pluginrouting_238d9aa9(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_19b70d34 === 'function') {
    await nuxt_plugin_pluginmain_19b70d34(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin63fa6690_6d4c3434 === 'function') {
    await nuxt_plugin_distplugin63fa6690_6d4c3434(app.context, inject)
  }

  if (typeof nuxt_plugin_image_498c57f8 === 'function') {
    await nuxt_plugin_image_498c57f8(app.context, inject)
  }

  if (typeof nuxt_plugin_coreplugine6901026_1f62471a === 'function') {
    await nuxt_plugin_coreplugine6901026_1f62471a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginse2etestinga6d710e6_d36a14fc === 'function') {
    await nuxt_plugin_pluginse2etestinga6d710e6_d36a14fc(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_9676b4f0 === 'function') {
    await nuxt_plugin_deviceplugin_9676b4f0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_546b04d9 === 'function') {
    await nuxt_plugin_workbox_546b04d9(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_3a8262ec === 'function') {
    await nuxt_plugin_metaplugin_3a8262ec(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_3f2a0860 === 'function') {
    await nuxt_plugin_iconplugin_3f2a0860(app.context, inject)
  }

  if (typeof nuxt_plugin_tokenexpired_ca1e20ca === 'function') {
    await nuxt_plugin_tokenexpired_ca1e20ca(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_fcPlugin_5a846bc6 === 'function') {
    await nuxt_plugin_fcPlugin_5a846bc6(app.context, inject)
  }

  if (typeof nuxt_plugin_dompurify_9e093c4a === 'function') {
    await nuxt_plugin_dompurify_9e093c4a(app.context, inject)
  }

  if (typeof nuxt_plugin_storeConfigPlugin_234467e0 === 'function') {
    await nuxt_plugin_storeConfigPlugin_234467e0(app.context, inject)
  }

  if (typeof nuxt_plugin_pwa_4462a11a === 'function') {
    await nuxt_plugin_pwa_4462a11a(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_515c203e === 'function') {
    await nuxt_plugin_meta_515c203e(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
